"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = __importDefault(require("../config"));
const axios_1 = __importDefault(require("axios"));
const query_string_1 = require("query-string");
class Auth {
    static async GetDeviceInfo() {
        try {
            const nav = navigator;
            const info = await Capacitor.Plugins.Device.getInfo();
            return {
                manufacturer: info.manufacturer,
                os: info.platform,
                os_version: info.osVersion,
                model: info.model,
                available_storage: info.realDiskFree ? this.ConvertToGigabytes(info.realDiskFree) : 0,
                memory: nav.deviceMemory ? nav.deviceMemory : 0
            };
        }
        catch (e) {
        }
    }
    static ConvertToGigabytes(bytes) {
        return parseFloat((bytes / (1000 * 1000 * 1000)).toFixed(2));
    }
    static async Login(org_code, username, password, environment) {
        const params = new URLSearchParams();
        const device_info = await this.GetDeviceInfo();
        if (device_info) {
            for (let key in device_info) {
                const value = device_info[key];
                params.append(key, value);
            }
        }
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        };
        const main_params = {
            username: username,
            password: password,
            organization: org_code
        };
        if (environment) {
            main_params.database = environment;
        }
        try {
            let data = await axios_1.default.post(`${config_1.default.ONLINE_API_URL}/api/token?${(0, query_string_1.stringify)(main_params)}`, params, options);
            if (config_1.default.IS_CLI) {
                if (data.headers['set-cookie'] && data.headers['set-cookie'].length > 0) {
                    config_1.default.SetCookie(data.headers['set-cookie'][0]);
                }
            }
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async ForgotPassword(username) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${config_1.default.ONLINE_API_URL}/api/v1/admin/users/forget-password?username=${username}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = Auth;
;
